module.exports = __webpack_public_path__ + "img/feedback-h.bdaf77a5.svg";